import React, { useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import {
  TextFieldCom,
  RadioFieldCom,
  SelectFieldCom,
  CascadeFieldCom,
  DatePickerCom,
} from '../../../components/FormType';
import { Fab, Button } from '@material-ui/core';
import ArchiveIcon from '@material-ui/icons/Archive';
import UnarchiveIcon from '@material-ui/icons/Unarchive';
import request from '@/utils/request';
import { Controller } from 'react-hook-form';
import FormHelperText from '@material-ui/core/FormHelperText';
import XLSX from 'xlsx';
import LabelRulesStyled from './LabelRulesStyled';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { useSelector, useDispatch } from 'dva';
import { getToken } from '@/utils/token';
import webStorage from '@/utils/storageManager';

const updateStrategyList = [
  // { label: '集合', value: '1' },
  { label: '数值', value: '3' },
  { label: '文本', value: '2' },
  { label: '日期', value: '4' },
];

const getDicList = (value, dicObj) => {
  if (value && Array.isArray(value) && value.length > 0) {
    const type = value[value.length - 1].conditionOneGroupType;

    return dicObj[type];
  }
  return [];
};
const getDicListTwo = (value, dicObj) => {
  if (value === 3) {
    return dicObj.PROFILE_ABSOLUTE_DATE_OPERATOR;
  } else if (value === 4) {
    return dicObj.PROFILE_RELATIVE_DATE_OPERATOR;
  }
  return [];
};

// eslint-disable-next-line no-unused-vars
// 级联最后一项
const checkTypeStatus = (value) => {
  if (value && Array.isArray(value) && value.length > 0) {
    const v = value[value.length - 1];
    return v;
  }
  return false;
};
// 校验
const checkForm = (data, errors) => {
  let status = false;
  data.forEach((item) => {
    for (let it in item) {
      if (errors && errors[`${it}-${item.id}`]) {
        status = true;
        break;
      }
    }
  });
  return status;
};
// eslint-disable-next-line no-unused-vars
//绝对时间，相对时间
const checkTypeStatusTwo = (value) => {
  //判断是否是时间类型，
  if (value && Array.isArray(value) && value.length > 0) {
    const v = value[value.length - 1].conditionTwoGroupType;
    return v ? v.split(',') : null;
  }
  return false;
};

// eslint-disable-next-line no-unused-vars
const checkTypeStatusThree = (value) => {
  //判断非时间是否是选择框
  if (value && Array.isArray(value) && value.length > 0) {
    const v = value[value.length - 1].fileType;
    return v;
  }
  return null;
};

const ISHAVEAVALUE = 1; //有值
const NOHAVEAVALUE = 2; //无值
const ISRELATIVE = 3; //绝对
const ISABSOLUTE = 4; //相对
const ISBEFORE = 3; //之前
const ISAFTER = 4; //之后

export default ({
  queryType, //编辑 详情
  control,
  errors,
  setValue,
  type, //标签类型
  handleAddRuleDetailData,
  setError,
  clearErrors,
  tagRule = null, //标签规则数据
  handleAddRuleDetailDataDelete, //删除
  setFieldValueP,
  ruleBehaviorData, //行为 取值方式对象
  getValues,
  setFileList,
  fileList,
}) => {
  const dispatch = useDispatch();
  //目录列表，行为列表
  const { tagBehaviorList, ruleLabelDirectoryList, queryTagOperatorValue } =
    useSelector((state) => state.createLabel);
  const { typeList } = useSelector((state) => state.crowdImport);
  const [disabled, setDisabled] = useState(false);
  // 获取字段列表数据
  const [ruleList, setRuleList] = useState([]);
  // // 行为id
  const [behaviorId, setBehaviorId] = useState('');
  const [number, setNumber] = useState(0);

  //取值方式
  const [beHavCondition, setBeHavCondition] = useState([]);

  // 字典项
  const {
    PROFILE_COLLECT_OPERATOR,
    PROFILE_DATE_OPERATOR, //日期类
    PROFILE_NUMERICAL_OPERATOR, //数值类
    TAG_RULE_BEHAVIOR, //行为
    PROFILE_TEXT_OPERATOR, //文本
    PROFILE_ABSOLUTE_DATE_OPERATOR, //绝对日期类
    PROFILE_RELATIVE_DATE_OPERATOR, //相对日期类
    PROFILE_RELATIVE_DATE_RANGE_OPERATOR, //相对日期范围操作
    PROFILE_FILE_VALUE_METHOD_NUMERICAL, //取值方式 数值
    PROFILE_FILE_VALUE_METHOD_TEXT, //文本
    PROFILE_FILE_VALUE_METHOD_DATE, //日期
  } = webStorage.get('DICTOBJ') || [];
  const dicObj = {
    PROFILE_COLLECT_OPERATOR,
    PROFILE_TEXT_OPERATOR,
    PROFILE_NUMERICAL_OPERATOR,
    PROFILE_DATE_OPERATOR,
    PROFILE_ABSOLUTE_DATE_OPERATOR,
    PROFILE_RELATIVE_DATE_OPERATOR,
    PROFILE_RELATIVE_DATE_RANGE_OPERATOR,
    PROFILE_FILE_VALUE_METHOD_NUMERICAL,
    PROFILE_FILE_VALUE_METHOD_TEXT,
    PROFILE_FILE_VALUE_METHOD_DATE,
  };

  //详情
  useEffect(() => {
    if (queryType === 'detail' || queryType === 'edit') {
      tagRule.length &&
        tagRule.forEach((item) => {
          setFileList(JSON.parse(item.url));
        });
      if (ruleBehaviorData) {
        if (type === '2') {
          setBeHavCondition(dicObj.PROFILE_FILE_VALUE_METHOD_TEXT);
        } else if (type === '3') {
          setBeHavCondition(dicObj.PROFILE_FILE_VALUE_METHOD_NUMERICAL);
        } else {
          setBeHavCondition(dicObj.PROFILE_FILE_VALUE_METHOD_DATE);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryType, ruleBehaviorData, tagRule, type]);

  useEffect(() => {
    tagRule.forEach((item) => {
      setValue(`valueFieldIds-${item.id}`, item.valueFieldIds);
      setValue(`operation-${item.id}`, item.operation);
      setValue(`operationValue-${item.id}`, item.operationValue);
      setValue(`operationAnd-${item.id}`, item.operationAnd);
      setValue(`operationAndValue-${item.id}`, item.operationAndValue);
      setValue(`operationType-${item.id}`, item.operationType);
    });
  }, [tagRule, setValue, number]);
  //行为
  const getFetchData = ({ value }) => {
    setValue('valueFieldIds', []);
    setBeHavCondition([]);
    setValue('valueMethod', '');
    setBehaviorId(value);
  };
  //取值方式
  const setBeConditionValue = ({ value }) => {
    setValue('valueMethod', '');
    if (value && Array.isArray(value)) {
      const { conditionTypeCode } = value[value.length - 1];
      const DICTOBJ = Object.keys(webStorage.get('DICTOBJ'));
      DICTOBJ.forEach((key) => {
        if (key === `${conditionTypeCode}`) {
          setBeHavCondition(webStorage.get('DICTOBJ')[key]);
        }
      });
    }
  };

  useEffect(() => {
    behaviorId &&
      dispatch({
        type: 'createLabel/queryTagBehaviorConditionList',
        payload: {
          values: { behaviorId: behaviorId, type: type },
        },
      });
  }, [behaviorId, dispatch, type]);

  const { tagBehaviorConditionList } = useSelector(
    (state) => state.createLabel,
  );

  //删除文件
  const handleFileListDetele = ({ selfId }) => {
    const list = fileList.filter((item) => item.id !== selfId);
    setFileList([...list]);
    setValue('url', list.length > 0 ? JSON.stringify(list) : '');
  };

  //下载文件
  const handleDownloadUrl = ({ selfId }) => {
    if (queryType === 'detail') {
      return;
    }
    fileList.forEach((item) => {
      if (item.id === selfId) {
        const apiToken = `${getToken()}`;
        const a = document.createElement('a');
        a.download = item.fileName;
        a.href = `${
          window.location.origin
        }/bizgrowth/web/v1/common/download?uri=${encodeURIComponent(
          item.url,
        )}&access_token=${apiToken}`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    });
  };

  const setFieldValue = (data) => {
    const { self, value } = data; //self =1 点击的第一个级联，self = 2点击的非时间的选择和时间的第二个条件选择，self=3点击的时间的第一个条件
    setFieldValueP(data);

    const today = new Date();
    const date =
      today.getFullYear() +
      '-' +
      (today.getMonth() + 1) +
      '-' +
      today.getDate();
    if (self === 1) {
      //重置后面所有的值
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operation',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationValue',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAnd',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAndValue',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationType',
      });
    } else if (self === 2) {
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationValue',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAnd',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAndValue',
      });
    } else if (self === 3) {
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operation',
      });
      setFieldValueP({
        ...data,
        value: value === 3 ? date : '',
        realName: 'operationValue',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAnd',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAndValue',
      });
    } else if (self === 4) {
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAndValue',
      });
    }
    setNumber(number + 1);
  };
  // function handleBehavior(list) {
  //   list &&
  //     list.forEach((item) => {
  //       setBehaviorId(item.id);
  //       // setBehaviorCode(item.behaviorCode);
  //     });
  // }

  // useEffect(() => [handleBehavior(tagBehaviorList)]);

  // 处理级联结构
  const handleOptions = (options) => {
    const newOptions = [];
    (options || []).forEach((item) => {
      const option = {
        ...item,
        value: item.fileName,
        label: item.fileName,
      };
      if (item.children) {
        option.children = handleOptions(
          // item.children.filter((v) => v.fileType === 5),
          item.children,
        );
      }
      newOptions.push(option);
    });
    return newOptions;
  };

  useEffect(() => {
    const newOptions = handleOptions(ruleLabelDirectoryList);
    setRuleList(newOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ruleLabelDirectoryList]);

  //关于文件信息
  // useEffect(() => {
  //   if (fileInfo?.fileName) {
  //     setFileName(fileInfo.fileName);
  //   }
  // }, [fileInfo]);
  //关于编辑状态
  useEffect(() => {
    if (queryType === 'detail') {
      setDisabled(true);
    }
  }, [queryType]);
  // const handleClearStatus = () => {
  //   setValue('status', '');
  // };
  const showLabelList = (ty) => {
    const showList = new Map([
      ['5', sqlLabel()],
      ['6', importLabel()],
      ['2', mathLabel()], //文本
      ['3', mathLabel()], //数值
      ['4', mathLabel()], //日期
      // ['2', textLabel()],
      // ['4', dateLabel()],
    ]);
    return showList.get(ty);
  };
  // 下载模版
  const handleClickDownload = () => {
    if (queryType === 'detail') {
      return;
    }
    const importId = getValues('importId');
    const url = typeList.find(
      (item) => item.value === importId,
    ).fileTemplateUrl;
    let aLink = document.createElement('a');
    aLink.download = 'ExternalTagBlankTamplate.xlsx'; //文件名随意
    aLink.href = `${process.env.FILE_URL}/${url}`;
    aLink.click();
    aLink.remove();
  };

  //生成唯一id
  function guid() {
    return Number(Math.random().toString().substr(3, 3) + Date.now()).toString(
      36,
    );
  }

  //获取接口返回的选择项
  const getFetchList = (value, data) => {
    let list = [];
    if (value && Array.isArray(value) && value.length > 0 && data) {
      const typeThree = value[value.length - 1].fileCodeEnumGroupType;
      data.forEach((item) => {
        if (item.labelGroup === typeThree) {
          list = item.valueAndLabelList;
          return;
        }
      });
    }
    return list;
  };

  // 上传文件
  const uploadFile = (formData, fileName) => {
    if (queryType !== 'detail') {
      request('/common/upload', {
        method: 'POST',
        data: formData,
      })
        .then((res) => {
          if (res.code === 0) {
            const fileObj = { id: guid(), ...res.data, fileName };
            setFileList([fileObj]);
            document.getElementById('inputFile').value = null;
            setValue('url', JSON.stringify(fileList));
          } else {
            window.message.toast({
              type: 'error',
              message: res.message,
              title: '失败',
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  // sql标签
  const sqlLabel = () => {
    return (
      <>
        <Box mt={3}>
          <RadioFieldCom
            initLabel={true} //自定义的label是否显示
            label="标签类型" //label
            queryType={queryType} //detail不可编辑用于详情
            fontSize="16px"
            control={control}
            lWidth="auto"
            name="ruleType"
            typeList={updateStrategyList}
          />
        </Box>
        <Box position="relative" height="100%" mt={1}>
          <TextFieldCom
            initLabel={false} //自定义的label是否显示
            showLabel={true} //是否需要显示label
            placeholder="请输入SQL公式"
            queryType={queryType} //detail不可编辑用于详情
            helperText="" //用于校验的提醒文字
            name="sqlText"
            label="SQL公式" //label
            control={control}
            errors={errors}
            setValue={setValue}
            isPositiveNumber={false} //true 只能输入正数，false可以输入负数
            isParseInt={false} //true 只能输入正整数，false可以输入小数
            rules={{
              required: true, //是否是必填项true 必填 false 非必填
            }}
            multiline
            maxRows={8}
            minRows={8}
            variant="outlined"
            className="textField-area-wrap"
          />
        </Box>
      </>
    );
  };
  // 外部导入标签
  const importLabel = () => {
    return (
      <Box className="external_import">
        <Box mt={3}>
          <RadioFieldCom
            initLabel={true} //自定义的label是否显示
            label="ID类型" //label
            queryType={queryType} //detail不可编辑用于详情
            fontSize="16px"
            control={control}
            lWidth="auto"
            name="importId"
            typeList={typeList}
          />
        </Box>
        <Box mt={3}>
          <RadioFieldCom
            initLabel={true} //自定义的label是否显示
            label="标签类型" //label
            queryType={queryType} //detail不可编辑用于详情
            fontSize="16px"
            control={control}
            lWidth="auto"
            name="ruleType"
            typeList={updateStrategyList}
          />
        </Box>
        <Box sx={{ fontSize: 16, mt: 3 }} style={{ color: '#212100' }}>
          <span style={{ color: 'red' }}>*</span>文件路径{' '}
          <span style={{ color: '#ccc', marginLeft: '12px', fontSize: '12px' }}>
            文件小于10M
          </span>
          {errors && errors.url && (
            <span
              style={{ color: 'red', fontSize: '12px', marginLeft: '10px' }}
            >
              上传文件是必选项
            </span>
          )}
        </Box>
        <div className="export-wrapper" style={{ marginTop: 12 }}>
          <Fab
            variant="extended"
            size="small"
            color={queryType === 'detail' ? '#fff' : 'primary'}
            aria-label="add"
            className="download"
            sx={{ mr: 1.6 }}
            onClick={handleClickDownload}
            disabled={queryType === 'detail' ? 'disabled' : null}
          >
            <ArchiveIcon sx={{ width: '24px', height: '24px' }} />
            下载模版
          </Fab>
          <Fab
            variant="extended"
            size="small"
            color={queryType === 'detail' ? '#fff' : 'primary'}
            aria-label="add"
            className="uploadFile"
            sx={{ position: 'relative' }}
            disabled={queryType === 'detail' ? 'disabled' : null}
          >
            <Controller
              render={(rp) => {
                return (
                  <input
                    className="fileInput"
                    name="url"
                    style={{
                      position: 'absolute',
                      left: '0px',
                      top: '0px',
                      opacity: 0,
                    }}
                    disabled={disabled}
                    type="file"
                    id="inputFile"
                    accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    label="上传文件"
                    rules={{ required: true }}
                    onChange={(e) => {
                      // setFileName(e.target.value); //"C:\fakepath\MemberBlackTemplate.csv"
                      let file = e.target.files;
                      if (file?.[0].size > 1024 * 1024 * 10) {
                        window.message.toast({
                          type: 'error',
                          message: '文件不能超过10M',
                          title: '失败',
                        });
                        document.getElementById('inputFile').value = null;
                        return;
                      }
                      let formData = new FormData(); //{}
                      const fileName = file[0].name; //文件名 MemberBlackTemplate.csv
                      if (file) {
                        const reader = new FileReader();
                        reader.readAsBinaryString(file[0]);
                        reader.onload = function (ed) {
                          try {
                            const data = ed.target.result;
                            const workbook = XLSX.read(data, {
                              type: 'binary',
                            });
                            const sheetName = workbook.SheetNames[0];
                            const worksheet = workbook.Sheets[sheetName];
                            const range = XLSX.utils.decode_range(
                              worksheet['!ref'],
                            );
                            const rowCount = range.e.r + 1;
                            if (!rowCount || rowCount < 2) {
                              window.message.toast({
                                type: 'error',
                                message: '上传的文件中没有数据',
                                title: '',
                              });
                              document.getElementById('inputFile').value = null;
                              return;
                            }
                            formData.append('file', file[0]);
                            formData.append('isFixedName', true);
                            formData.append('isPublic', false);
                            formData.append(
                              'bucket',
                              'PROFILE_TAG_PACK_IMPORT',
                            );
                            uploadFile(formData, fileName);
                          } catch (error) {
                            formData.append('file', file[0]);
                            formData.append('isFixedName', true);
                            formData.append('isPublic', false);
                            formData.append(
                              'bucket',
                              'PROFILE_TAG_PACK_IMPORT',
                            );
                            uploadFile(formData, fileName);
                          }
                        };
                      }
                      return rp.onChange(e);
                    }}
                  />
                );
              }}
              name="url"
              type="file"
              label="上传文件"
              control={control}
              rules={{ required: true }}
            />
            <FormHelperText error={Boolean(errors.file)}>
              {Boolean(errors?.file?.type === 'required') && '请上传文件'}
            </FormHelperText>
            <UnarchiveIcon sx={{ width: '24px', height: '24px' }} />
            上传文件
          </Fab>
        </div>
        {fileList &&
          fileList.map((item) => {
            return (
              <Box
                className="file_name"
                mt={2.6}
                style={{
                  color: queryType === 'detail' ? '#ccc' : '##1565c0',
                }}
                key={item.id}
              >
                <span
                  style={{
                    cursor: queryType === 'detail' ? 'default' : 'pointer',
                  }}
                  onClick={() => {
                    handleDownloadUrl({ selfId: item.id });
                  }}
                >
                  {item.fileName}
                </span>
                {queryType === 'detail' ? (
                  ''
                ) : (
                  <HighlightOffIcon
                    sx={{
                      width: '24px',
                      height: '24px',
                      color: 'rgba(0, 0, 0, 0.26)',
                      marginLeft: '9px',
                      cursor: 'pointer',
                      verticalAlign: 'middle',
                    }}
                    key={item.id}
                    onClick={() => {
                      handleFileListDetele({ selfId: item.id });
                    }}
                  />
                )}
              </Box>
            );
          })}
      </Box>
    );
  };
  // 数值、文本、日期类标签
  const mathLabel = () => {
    return (
      <Box className="math_label">
        <Box className="title">
          <span style={{ color: 'red' }}>*</span>条件范围{' '}
          <span style={{ color: '#f44336', fontSize: '.75rem' }}>
            {checkForm(tagRule, errors) && '此项有未完成输入或选择项'}
          </span>
        </Box>
        {tagRule &&
          Array.isArray(tagRule) &&
          tagRule.length > 0 &&
          tagRule.map((item, ind) => {
            return (
              <Box
                key={ind}
                sx={{
                  display: 'flex',
                  gap: '0 32px',
                  paddingLeft: '16px',
                  alignItems: 'flex-end',
                }}
              >
                <Box sx={{ width: '200px' }}>
                  <CascadeFieldCom
                    label="请选择标签"
                    showLabel={false} //是否需要显示label
                    showError={false} //false输入框捕获到错误不展示错误样式，默认true
                    cascadeData={ruleList}
                    queryType={queryType}
                    setValue={setValue}
                    control={control}
                    name={'valueFieldIds-' + item.id}
                    realName="valueFieldIds"
                    fieldNames={{ label: 'fileName', value: 'id' }}
                    nameMessage="标签是必选项"
                    errors={errors}
                    setError={setError}
                    clearErrors={clearErrors}
                    setFieldValue={setFieldValue}
                    isShowSearch={true} //开启搜索
                    parameter={{
                      selfId: item.id,
                      self: 1,
                    }}
                    rules={{
                      required: true, //是否是必填项true 必填 false 非必填
                      validate: (value) => value?.length > 0,
                    }}
                  />
                </Box>
                {checkTypeStatus(item.valueFieldIds) &&
                  !checkTypeStatusTwo(item.valueFieldIds) && (
                    <Box width="140px" display="flex" alignItems="flex-end">
                      <SelectFieldCom
                        label="条件"
                        placeholder="请选择条件"
                        initLabel=""
                        name={'operation-' + item.id}
                        realName="operation"
                        queryType={queryType}
                        setValue={setValue}
                        control={control}
                        errors={errors}
                        setError={setError}
                        clearErrors={clearErrors}
                        nameMessage=""
                        // setBehaviorId={setBehaviorId}
                        typeList={getDicList(item.valueFieldIds, dicObj)}
                        setFieldValue={setFieldValue}
                        parameter={{
                          selfId: item.id,
                          self: 2,
                        }}
                        fieldNames={{
                          label: 'nameZh',
                          value: 'dictValue',
                        }}
                        rules={{
                          required: true,
                        }}
                      />
                    </Box>
                  )}
                {/*时间的第一个选择*/}
                {checkTypeStatus(item.valueFieldIds) &&
                  checkTypeStatusTwo(item.valueFieldIds) && (
                    <Box width="140px" display="flex" alignItems="flex-end">
                      <SelectFieldCom
                        label="条件"
                        initLabel=""
                        placeholder="请选择条件"
                        name={'operationType-' + item.id}
                        realName="operationType"
                        queryType={queryType}
                        setValue={setValue}
                        control={control}
                        errors={errors}
                        setError={setError}
                        clearErrors={clearErrors}
                        nameMessage=""
                        typeList={getDicList(item.valueFieldIds, dicObj)}
                        setFieldValue={setFieldValue}
                        parameter={{
                          selfId: item.id,
                          self: 3,
                        }}
                        fieldNames={{
                          label: 'nameZh',
                          value: 'dictValue',
                        }}
                        rules={{
                          required: true,
                        }}
                      />
                    </Box>
                  )}
                {/*第二个输入框 非时间输入框*/}
                {!checkTypeStatusTwo(item.valueFieldIds) &&
                  checkTypeStatusThree(item.valueFieldIds) !== 8 &&
                  checkTypeStatus(item.valueFieldIds) &&
                  item.operation !== ISHAVEAVALUE &&
                  item.operation !== NOHAVEAVALUE && (
                    <Box
                      display="flex"
                      alignItems="flex-end"
                      position="relative"
                      bottom="-4px"
                      width="118"
                    >
                      <TextFieldCom
                        autoFocus={false} //If true, the input element is focused during the first mount.
                        initLabel={false} //自定义的label是否显示
                        showLabel={false} //是否需要显示label
                        placeholder="请输入"
                        queryType={queryType} //detail不可编辑用于详情
                        helperText="" //用于校验的提醒文字
                        name={`operationValue-${item.id}`}
                        label="" //label
                        control={control}
                        errors={errors}
                        // endAdornment="天"
                        setValue={setValue}
                        isTextLimt={false} //限制输入- . ,首位不以0开头
                        isNumber={false}
                        isPositiveNumber={false} //true 只能输入正数，false可以输入负数
                        isParseInt={false} //true 只能输入正整数，false可以输入小数
                        showError={false} //false输入框捕获到错误不展示错误样式，默认true
                        realName="operationValue"
                        setFieldValue={setFieldValue}
                        parameter={{
                          selfId: item.id,
                        }}
                        rules={{
                          required: true,
                        }}
                        initHeight={{ height: 'auto' }}
                      />
                    </Box>
                  )}
                {!checkTypeStatusTwo(item.valueFieldIds) &&
                  checkTypeStatusThree(item.valueFieldIds) === 8 &&
                  checkTypeStatus(item.valueFieldIds) &&
                  item.operation !== ISHAVEAVALUE &&
                  item.operation !== NOHAVEAVALUE && (
                    <Box width="109px" display="flex" alignItems="flex-end">
                      <SelectFieldCom
                        label="条件"
                        initLabel=""
                        placeholder="请选择"
                        name={'operationValue-' + item.id}
                        realName="operationValue"
                        queryType={queryType}
                        setValue={setValue}
                        control={control}
                        errors={errors}
                        setError={setError}
                        clearErrors={clearErrors}
                        nameMessage=""
                        // defaultValue={it?.operationType}
                        typeList={getFetchList(
                          item.valueFieldIds,
                          queryTagOperatorValue,
                        )}
                        setFieldValue={setFieldValue}
                        parameter={{
                          wid: item.id,
                          selfId: item.id,
                        }}
                        fieldNames={{
                          label: 'nameZh',
                          value: 'labelCode',
                        }}
                        rules={{
                          required: true, //是否是必填项true 必填 false 非必填
                        }}
                      />
                    </Box>
                  )}
                {checkTypeStatusTwo(item.valueFieldIds) &&
                  item.operationType &&
                  item.operationType !== ISHAVEAVALUE &&
                  item.operationType !== NOHAVEAVALUE && (
                    <Box width="140px" display="flex" alignItems="flex-end">
                      <SelectFieldCom
                        label="日期的第二个条件"
                        placeholder="请选择条件"
                        initLabel=""
                        name={'operation-' + item.id}
                        queryType={queryType}
                        setValue={setValue}
                        control={control}
                        errors={errors}
                        setError={setError}
                        clearErrors={clearErrors}
                        nameMessage="日期的第二个条件"
                        typeList={getDicListTwo(item.operationType, dicObj)}
                        fieldNames={{
                          label: 'nameZh',
                          value: 'dictValue',
                        }}
                        realName="operation"
                        setFieldValue={setFieldValue}
                        parameter={{
                          selfId: item.id,
                        }}
                        rules={{
                          required: true,
                        }}
                      />
                    </Box>
                  )}
                {checkTypeStatusTwo(item.valueFieldIds) &&
                  item.operationType === ISRELATIVE && (
                    <Box width="140px" display="flex" alignItems="flex-end">
                      <DatePickerCom
                        showError={false} //false输入框捕获到错误不展示错误样式，默认true  绝对时间
                        name={'operationValue-' + item.id}
                        showLabel={false}
                        rules={{
                          required: true,
                        }}
                        label=""
                        defaultValue={item.operationValue ?? new Date()}
                        queryType={queryType}
                        setValue={setValue}
                        control={control}
                        errors={errors}
                        setError={setError}
                        clearErrors={clearErrors}
                        realName="operationValue"
                        setFieldValue={setFieldValue}
                        parameter={{
                          selfId: item.id,
                        }}
                      />
                    </Box>
                  )}
                {/*相对时间的第一个输入框*/}
                {checkTypeStatusTwo(item.valueFieldIds) &&
                  item.operationType === ISABSOLUTE && (
                    <Box
                      width="118px"
                      display="flex"
                      alignItems="flex-end"
                      position="relative"
                      bottom={queryType !== 'detail' ? '-4px' : 0}
                    >
                      <TextFieldCom
                        autoFocus={false} //If true, the input element is focused during the first mount.
                        initLabel={false} //自定义的label是否显示
                        showLabel={false} //是否需要显示label
                        placeholder="请输入"
                        queryType={queryType} //detail不可编辑用于详情
                        helperText="" //用于校验的提醒文字
                        name={`operationValue-${item.id}`}
                        label="条件2数值" //label
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        isNumber={true}
                        isPositiveNumber={true} //true 只能输入正数，false可以输入负数
                        isParseInt={true} //true 只能输入正整数，false可以输入小数
                        showError={false} //false输入框捕获到错误不展示错误样式，默认true
                        rules={{
                          required: true,
                        }}
                        initHeight={{ height: 'auto' }}
                        realName="operationValue"
                        setFieldValue={setFieldValue}
                        parameter={{
                          selfId: item.id,
                        }}
                      />
                      <div
                        style={{
                          paddingBottom: '3px',
                          marginLeft: '3px',
                          color:
                            queryType === 'detail'
                              ? 'rgba(0, 0, 0, 0.38)'
                              : '##1565c0',
                        }}
                      >
                        天
                      </div>
                    </Box>
                  )}
                {/*相对时间的条件3*/}
                {checkTypeStatusTwo(item.valueFieldIds) &&
                  item.operationType === ISABSOLUTE && (
                    <Box width="140px" display="flex" alignItems="flex-end">
                      <SelectFieldCom
                        label="条件3"
                        placeholder="请选择条件"
                        initLabel=""
                        name={'operationAnd-' + item.id}
                        queryType={queryType}
                        setValue={setValue}
                        control={control}
                        errors={errors}
                        setError={setError}
                        clearErrors={clearErrors}
                        nameMessage="条件2必选项"
                        typeList={dicObj.PROFILE_RELATIVE_DATE_RANGE_OPERATOR}
                        fieldNames={{
                          label: 'nameZh',
                          value: 'dictValue',
                        }}
                        realName="operationAnd"
                        setFieldValue={setFieldValue}
                        parameter={{
                          selfId: item.id,
                          self: 4,
                        }}
                        rules={{
                          required: true,
                        }}
                      />
                    </Box>
                  )}
                {checkTypeStatusTwo(item.valueFieldIds) &&
                  item.operationType === ISABSOLUTE &&
                  item.operationAnd &&
                  item.operationAnd !== ISBEFORE &&
                  item.operationAnd !== ISAFTER && (
                    <Box
                      width="118px"
                      display="flex"
                      alignItems="flex-end"
                      position="relative"
                      bottom="-4px"
                    >
                      <TextFieldCom
                        autoFocus={false} //If true, the input element is focused during the first mount.
                        initLabel={false} //自定义的label是否显示
                        showLabel={false} //是否需要显示label
                        placeholder="请输入"
                        queryType={queryType} //detail不可编辑用于详情
                        helperText="" //用于校验的提醒文字
                        name={`operationAndValue-${item.id}`}
                        label="条件4数值" //label
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        isNumber={true}
                        isPositiveNumber={true} //true 只能输入正数，false可以输入负数
                        isParseInt={true} //true 只能输入正整数，false可以输入小数
                        showError={false} //false输入框捕获到错误不展示错误样式，默认true
                        rules={{
                          required: true,
                        }}
                        initHeight={{ height: 'auto' }}
                        realName="operationAndValue"
                        setFieldValue={setFieldValue}
                        parameter={{
                          selfId: item.id,
                        }}
                      />
                      <div
                        style={{
                          paddingBottom: '3px',
                          marginLeft: '3px',
                          color:
                            queryType === 'detail'
                              ? 'rgba(0, 0, 0, 0.38)'
                              : '##1565c0',
                        }}
                      >
                        天
                      </div>
                    </Box>
                  )}
                {tagRule.length > 1 && queryType !== 'detail' && (
                  <Box display="flex" alignItems="flex-end">
                    <HighlightOffIcon
                      sx={{
                        width: '24px',
                        height: '24px',
                        marginLeft: '5px',
                        color: 'rgba(0, 0, 0, 0.87)',
                        cursor: 'pointer',
                      }}
                      onClick={() =>
                        handleAddRuleDetailDataDelete({
                          selfId: item.id,
                        })
                      }
                    />
                  </Box>
                )}
                {tagRule.length - 1 === ind && queryType !== 'detail' && (
                  <Button
                    variant="contained"
                    sx={{
                      width: '61px',
                      height: '36px',
                      background: '#1565C0',
                      marginLeft: '77px',
                      marginBottom: '-10px',
                    }}
                    onClick={handleAddRuleDetailData}
                  >
                    新增
                  </Button>
                )}
              </Box>
            );
          })}
        <Box className="title">
          <span style={{ color: 'red' }}>*</span>行为{' '}
          {(errors.behaviorType || errors.behaviorId) && (
            <span style={{ color: 'red', fontSize: '.75rem' }}>
              此项有未完成的选择项
            </span>
          )}
        </Box>
        <Box className="line" sx={{ gap: '0 32px' }}>
          <Box width="200px" display="flex" alignItems="flex-end">
            <SelectFieldCom
              label="行为1"
              initLabel=""
              placeholder="请选择"
              name="behaviorType"
              queryType={queryType}
              setValue={setValue}
              control={control}
              errors={errors}
              setError={setError}
              clearErrors={clearErrors}
              showError={false}
              // nameMessage="行为是必选项"
              typeList={TAG_RULE_BEHAVIOR || []}
              fieldNames={{ label: 'nameZh', value: 'dictValue' }}
              rules={{
                required: true,
              }}
            />
          </Box>
          <Box width="200px" display="flex" alignItems="flex-end" ml={1}>
            <SelectFieldCom
              label="行为2"
              initLabel=""
              placeholder="请选择"
              name="behaviorId"
              queryType={queryType}
              setValue={setValue}
              control={control}
              errors={errors}
              setError={setError}
              showError={false}
              clearErrors={clearErrors}
              // nameMessage="行为是必选项"
              typeList={tagBehaviorList || []}
              // fieldNames={{ label: 'behaviorName', value: 'id' }}
              fieldNames={{ label: 'nameZh', value: 'dictValue' }}
              setFieldValue={getFetchData}
              rules={{
                required: true,
              }}
            />
          </Box>
        </Box>
        <Box className="title">
          <span style={{ color: 'red' }}>*</span>取值方式{' '}
          {(errors.valueFieldIds || errors.valueMethod) && (
            <span style={{ color: 'red', fontSize: '.75rem' }}>
              此项有未完成的选择项
            </span>
          )}
        </Box>
        <Box className="line" sx={{ gap: '0 32px' }}>
          <Box sx={{ width: '200px' }}>
            <CascadeFieldCom
              label="请选择"
              showLabel={false} //是否需要显示label
              showError={false} //false输入框捕获到错误不展示错误样式，默认true
              cascadeData={tagBehaviorConditionList || []}
              queryType={queryType}
              setValue={setValue}
              control={control}
              name="valueFieldIds"
              realName="valueFieldIds"
              fieldNames={{ label: 'fileName', value: 'id' }}
              nameMessage="取值方式是必选项"
              errors={errors}
              setError={setError}
              clearErrors={clearErrors}
              setFieldValue={setBeConditionValue}
              isShowSearch={true} //开启搜索
              parameter={{}}
              rules={{
                required: true,
                validate: (value) => value?.length > 0,
              }}
            />
          </Box>
          <Box width="200px" display="flex" alignItems="flex-end" ml={1}>
            <SelectFieldCom
              label="取值2"
              initLabel=""
              placeholder="请选择"
              name="valueMethod"
              queryType={queryType}
              setValue={setValue}
              control={control}
              errors={errors}
              setError={setError}
              clearErrors={clearErrors}
              nameMessage="取值方式是必选项"
              typeList={beHavCondition || []}
              showError={false}
              fieldNames={{ label: 'nameZh', value: 'dictValue' }}
              rules={{
                required: true,
              }}
            />
          </Box>
        </Box>
      </Box>
    );
  };

  return (
    <LabelRulesStyled
      queryType={queryType}
      color={queryType === 'detail' ? 'rgba(0, 0, 0, 0.38)' : '##1565c0'}
    >
      <Box>{type && showLabelList(type)}</Box>
    </LabelRulesStyled>
  );
};
